module.exports = __webpack_public_path__ + "img/alfa.fb28c52d.png";